import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { LazyImageProvider } from 'trellis-ecosystem';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { PartnerInfoSection } from './PartnerInfoSection';
import { StorefrontListingCard } from './cards/StorefrontListingCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DetailsSuggestionSection({
  productType
}) {
  var _data$result$sections;
  const {
    isMobile,
    isSideBySide
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      md: false
    },
    isSideBySide: {
      xs: false,
      xl: true
    }
  });
  const cardsDirection = isMobile ? 'column' : 'row';
  const mainDirection = isSideBySide ? 'row' : 'column';
  const shouldWrapPartner = !isMobile && !isSideBySide;
  const {
    loading,
    error,
    data
  } = useGetSuggestionSections({
    productTypes: productType ? [productType] : ['APP', 'AGENT'],
    maximumSections: 1,
    minimumSectionCardCount: 2,
    maximumSectionCardCount: 2
  });
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlockStart: "1200",
      size: "medium"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    });
  }
  const section = data === null || data === void 0 || (_data$result$sections = data.result.sections) === null || _data$result$sections === void 0 ? void 0 : _data$result$sections[0];
  const suggestionCards = section === null || section === void 0 ? void 0 : section.cards;
  const title = (section === null || section === void 0 ? void 0 : section.title) || '';
  const cardsContainer = /*#__PURE__*/_jsx(Flex, {
    alignItems: "stretch",
    flexDirection: cardsDirection,
    flex: shouldWrapPartner ? undefined : '1',
    gap: "600",
    children: suggestionCards === null || suggestionCards === void 0 ? void 0 : suggestionCards.map((card, index) => /*#__PURE__*/_jsx(Flex, {
      alignItems: "stretch",
      flex: "1",
      children: /*#__PURE__*/_jsx(StorefrontListingCard, {
        card: card,
        resultCount: suggestionCards.length,
        resultIndex: index
      })
    }, card.listingId))
  });
  const partnerSection = /*#__PURE__*/_jsx(PartnerInfoSection, {
    flex: shouldWrapPartner ? undefined : '1'
  });
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "1200",
    children: /*#__PURE__*/_jsxs(LazyImageProvider, {
      children: [title && /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "400",
        marginInlineStart: "-50",
        typography: "heading-300",
        children: title
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flexDirection: mainDirection,
        gap: "600",
        marginBlockStart: "800",
        minBlockSize: "320px",
        children: [cardsContainer, partnerSection]
      })]
    })
  });
}